import type { IconDef } from '../types';

export const leftArrow: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M9.62401 21.0498C10.0142 20.6597 10.0142 20.0294 9.62401 19.6392L3.40142 13.4166L22.9996 13.4166C23.5498 13.4166 24 12.9664 24 12.4162C24 11.866 23.5498 11.4158 22.9996 11.4158L3.40142 11.4158L9.62401 5.20321C10.0142 4.81305 10.0142 4.18278 9.62401 3.79262C9.23385 3.40246 8.60358 3.40246 8.21342 3.79262L0.290119 11.7159C0.090036 11.916 -3.78808e-07 12.1661 -3.90177e-07 12.4262C-4.01547e-07 12.6863 0.10004 12.9364 0.290119 13.1365L8.21342 21.0598C8.60358 21.45 9.23385 21.45 9.62401 21.0598L9.62401 21.0498Z',
    },
  ],
};
